const SESSION_KEYS = ['token', 'role', 'adminName', 'adminEmail', 'template', 'templateName', 'business', 'businessName'];

export const getRole     = () => localStorage.getItem('role') || '';
export const getBusiness = () => localStorage.getItem('business') || '';
export const getTemplate = () => localStorage.getItem('template') || '';
export const getTemplateName = () => localStorage.getItem('templateName') || '';
export const getToken    = () => localStorage.getItem('token') || '';
export const isSuperAdmin = () => getRole() === 'superadmin';
export const isAdmin      = () => getRole() === 'admin';

export const getAdminName = () =>
  localStorage.getItem('adminName') || (isSuperAdmin() ? 'Super Admin' : 'Admin');

// Stores the response of POST /api/admins/login: { token, admin: { name, email, role, template } }
export const saveSession = ({ token, admin }) => {
  localStorage.setItem('token', token);
  localStorage.setItem('role', admin.role);
  localStorage.setItem('adminName', admin.name || '');
  localStorage.setItem('adminEmail', admin.email || '');
  localStorage.setItem('template', admin.template?.id || '');
  localStorage.setItem('templateName', admin.template?.name || '');
};

export const clearSession = () => SESSION_KEYS.forEach(k => localStorage.removeItem(k));

export const authHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${getToken()}`
});
